import {Dictionary} from "vue-router/types/router";

export class GtmScript {

    /** gtm.jsスクリプト要素 */
    private script: HTMLScriptElement = null;

    /** スクリプトのロード有無（true:ロード済、false:未ロード） */
    private loaded: boolean = false;

    /**
     * GTMスクリプトをロードします。
     * @param id GTM ID
     */
    public loadScript(id: string) {

        if (!id) {
            console.log('GTM ID is null.');
            return;
        }

        // iframeタグを生成する
        this.createIframe(id);

        // src URL情報
        const source: string = 'https://www.googletagmanager.com/gtm.js';
        const query: string = `id=${id}`;

        // scriptタグを生成する
        this.script = document.createElement('script');
        this.script.src = `${source}?${query}`;

        // スクリプトロード後のイベントで「gtm.start'」をwindow.dataLayerに追加する
        const scriptLoadListener: (event: Event) => void = () => {
            this.script.removeEventListener('load', scriptLoadListener);

            // @ts-ignore
            const dataLayer = window.dataLayer || []
            dataLayer.push({
                event: 'gtm.js',
                'gtm.start': new Date().getTime(),
            });
            this.loaded = true;
        };
        this.script.addEventListener('load', scriptLoadListener);

        // スクリプトの属性を設定
        this.script.async = true;
        this.script.defer = false; // falseは非同期

        // headタグにscriptタグを埋め込む
        document.head.appendChild(this.script);
    }


    /**
     * GA用のiframeタグをnoscript内に生成します。
     *
     * 生成するタグの内容は以下の通りです。
     * <noscript><iframe src="https://www.googletagmanager.com/ns.html?id=GTM-NC786LS"
     * height="0" width="0" style="display:none;visibility:hidden"></iframe></noscript>
     * @param id GTM ID
     * @private
     */
    private createIframe(id: string) {
        const source: string = 'https://www.googletagmanager.com/ns.html';
        const query: string = `id=${id}`;

        // iframeタグを生成する
        const iframe = document.createElement('iframe');
        iframe.src = `${source}?${query}`;
        iframe.height = '0';
        iframe.width = '0';
        iframe.style.cssText = 'display:none;visibility:hidden';

        // noscriptタグの先頭にiframeタグを追加する
        document.getElementsByTagName('noscript')[0].prepend(iframe);
    }

    /**
     * GTMにページ遷移のイベントを通知します。
     * @param pageName ページパス
     * @param query クエリパラメータ
     */
    public noticeContentsLoad(pageName: string, query: Dictionary<string | (string | null)[]>) {
        // GTM IDが未設定でscriptがnullの場合は処理を実行しない。
        if (!this.script) {
            return;
        }

        // queryにリダイレクトURLが存在しない場合、セッションストレージから取得する
        let redirectUri = (query.redirectUrl) ? query.redirectUrl.toString() : null;
        redirectUri = redirectUri || sessionStorage.getItem("redirectUrl") || sessionStorage.getItem("redirectUrlForMail") || undefined;

        // dataLayerにpushする関数を定義
        let pushToDataLayer = () => {
            // @ts-ignore
            const dataLayer = window.dataLayer || []
            dataLayer.push({
                event: 'contents_load',
                virtualpage_name: pageName,
                user_id: sessionStorage.getItem("gtm_auth_id") || undefined, // Auth0 ユーザIDのハッシュ値はセッションストレージから取得
                redirect_url: redirectUri,
            });
        }

        // Routerにおいては、scriptタグが未ロードの可能性があるため、ロード状態によって処理を切り分ける
        if (this.loaded) {
            // ロード済の場合、push関数をそのまま実行する
            pushToDataLayer();
        } else {
            // 未ロードの場合は、push関数をLoadイベント後に実行する
            const scriptLoadListenerForDataLayer: (event: Event) => void = () => {
                this.script.removeEventListener('load', scriptLoadListenerForDataLayer);
                pushToDataLayer();
            };
            this.script.addEventListener('load', scriptLoadListenerForDataLayer);
        }
    }

    /**
     * 離脱リンククリックのイベントを通知します。
     * 画面から呼ばれること（scriptタグがロード済であること）を前提とします。
     */
    public static noticeMyPageRedirectClick() {
        // queryをセッションストレージから取得する
        let redirectUri = sessionStorage.getItem("redirectUrl") || sessionStorage.getItem("redirectUrlForMail") || undefined;

        // @ts-ignore
        const dataLayer = window.dataLayer || []
        dataLayer.push({
            event: 'mypage_redirect_click',
            redirect_url: redirectUri,
            user_id: sessionStorage.getItem("gtm_auth_id") || undefined, // Auth0 ユーザIDのハッシュ値はセッションストレージから取得
        });
    }
}